import React from 'react';
import './homolog.css';
import { FaWhatsapp } from 'react-icons/fa';
import { useLanguage } from '../../LanguageContext';

const WhatsappFooter = props => {
    const { translations, changeLanguage, language } = useLanguage();
    let { flag } = props;

    // Determine which WhatsApp number to use
    let whatsappNumber;
    const selectedBranch = sessionStorage.getItem('_filialSelecionada');

    if (language === "en-US") {
        whatsappNumber = "+5214461336886";
    } else if (selectedBranch === "2") {
        whatsappNumber = "+5214425820239";
    } else {
        whatsappNumber = "+5215579787204";
    }

    const whatsappUrl = `https://wa.me/${whatsappNumber}`;

    // Determine button text based on language
    const buttonText = language === "en-US" ? "Send message" : "Enviar mensaje";

    if (flag !== "true") {
        return (
            <div>
                <button onClick={() => window.open(whatsappUrl, '_blank')} className="whatsapp-btn">
                    <FaWhatsapp />
                </button>

                <div className="whatsapp-envia-mensagem">
                    <p>{buttonText}</p>
                </div>
            </div>
        )
    }

    return (
        <div>
            <button onClick={() => window.open(whatsappUrl, '_blank')} className="whatsapp-btn whatsapp-btn-homolog">
                <FaWhatsapp />
            </button>

            <div className="whatsapp-envia-mensagem">
                <p>{buttonText}</p>
            </div>
        </div>
    )
}

export default WhatsappFooter;